import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "@components/Sidebar";
import { Header } from "@components/Header";
import { BottomNavigation } from "@components/BottomNavigation";
import ProfileCompletionBanner from "@components/ProfileCompletionBanner";
import { useAuth } from "@hooks/useAuth";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import SpinnerOverlay from "@components/ui/SpinnerOverlay";
import Chatbot from "@/components/Chatbot";


export function ProtectedFullLayout() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation();
  const { user } = useAuth();
  const isFetching = useIsFetching({
    predicate: (query) => !query.meta?.suppressGlobalLoader
  });
  const isMutating = useIsMutating({
    predicate: (mutation) => !mutation.meta?.suppressGlobalLoader
  });
  const isLoading = isFetching > 0 || isMutating > 0;

  return (
    <>
      <Header />
      <Sidebar onCollapseChange={setIsSidebarCollapsed} />
      <main
        className={`transition-all duration-300 relative flex-1 ${
          // Add bottom padding on mobile if navigation is visible (not in discussion chat)
          location.pathname.includes('/discussions') && !!new URLSearchParams(location.search).get('discussionId')
            ? ""
            : "pb-28 md:pb-0"
          } ${isSidebarCollapsed ? "md:ml-16" : "md:ml-64"}`}
      >
        {isLoading && <SpinnerOverlay inline />}
        {!user?.profileComplete && !location.pathname.includes('/discussions') && <ProfileCompletionBanner />}
        <Outlet />
      </main>
      <BottomNavigation />
      {!location.pathname.includes('/discussions') && <Chatbot className="hidden md:block" />}
    </>
  );
}
